import { getValidatorFromString } from '@core/validators';

export default {
    methods: {
        getValidatorFromString,
        validate() {
            let isValid = false;

            const inputs = Object.keys(this.$refs).filter(ref => ref.startsWith('input.'));

            const validity = {
                total: inputs.length,
                valid: 0
            };

            for (const input of inputs) {
                let $ref = this.$refs[`${input}`];

                if (Array.isArray($ref)) {
                    $ref = $ref[0];
                }

                if ($ref && typeof $ref.validate === 'function') {
                    if ($ref.validate(true) === true) {
                        validity.valid++;
                    }
                } else {
                    validity.valid++;
                    console.info(
                        // eslint-disable-next-line max-len
                        `function 'validate()' not found when trying to validate input of ${this.$options.name}: ${input}`
                    );
                }
            }

            isValid = validity.total === validity.valid;

            if (this.$refs['input-error']) {
                if (typeof this.$refs['input-error'].validate === 'function') {
                    if (this.$refs['input-error'].validate(true) !== true) {
                        isValid = false;
                    }
                }
            }

            if (this.$refs['input']) {
                if (typeof this.$refs['input'].validate === 'function') {
                    if (this.$refs['input'].validate(true) !== true) {
                        isValid = false;
                    }
                } else {
                    console.info(
                        `function 'validate()' not found when trying to validate input of ${this.$options.name}`
                    );
                }
            }

            return isValid;
        }
    }
};
